export class Utilities {
  static clone(object: any) {
    return object ? JSON.parse(JSON.stringify(object)) : object;
  }
}
